import { foldazApi } from 'api'
import {
  FETCH_INVITATIONS_REQUEST,
  FETCH_INVITATIONS_SUCCESS,
  FETCH_INVITATIONS_ERROR,
  SET_INVITATIONS,
  DELETE_INVITATION,
  SET_META
} from './types'

export const state = {
  entries: [],
  meta: null,
  request: {
    isLoading: false,
    error: null
  }
}

export const mutations = {
  [FETCH_INVITATIONS_REQUEST] (state) {
    state.request.isLoading = true
  },
  [FETCH_INVITATIONS_SUCCESS] (state) {
    state.request.isLoading = false
    state.request.error = null
  },
  [FETCH_INVITATIONS_ERROR] (state, error) {
    state.request.isLoading = false
    state.request.error = error
  },
  [SET_INVITATIONS] (state, value) {
    state.entries = value
  },
  [SET_META] (state, value) {
    state.meta = value
  },
  [DELETE_INVITATION] (state, value) {
    const index = state.entries.findIndex(entry => entry.id == value)
    state.entries.splice(index, 1)
  }
}

export const actions = {
  fetchInvitations ({ commit }, params) {
    commit(FETCH_INVITATIONS_REQUEST)
    return foldazApi.get('/invitations', {
      params: params
    })
      .then(({ data }) => {
        commit(SET_META, data.meta)
        commit(SET_INVITATIONS, data.entries)
      })
      .then(() => commit(FETCH_INVITATIONS_SUCCESS))
      .catch(error => commit(FETCH_INVITATIONS_ERROR, error))
  },

  deleteInvitation ({ commit }, invitationId) {
    return foldazApi.delete(`/invitations/${invitationId}`)
      .then(() => {
        commit(DELETE_INVITATION, invitationId)
      })
  },

  resetInvitations ({ commit }) {
    commit(SET_INVITATIONS, [])
  }
}

export const getters = {
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/invitations/invitations.js